module.exports = __webpack_public_path__ + "static/img/index1.654d67b.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/index1.png
// module id = Xs2G
// module chunks = 7